var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-crud',{attrs:{"crudName":"Innovare TI - Daily","newText":"Responder Daily","table":_vm.projectTable,"columns":_vm.columns,"options":_vm.options,"endPoint":_vm.endPoint,"enableAdd":true,"enableEdit":false,"enableDelete":false,"customFilters":_vm.customFilters,"enableView":true},on:{"filtered":_vm.filtered}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }